// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapping-container {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}
.mapping-container .mapping-search-back {
  padding: 20px 0;
  color: blue;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.mapping-container .mapping-search-bar {
  flex-direction: column;
  align-items: flex-start;
  margin: 20px 0 30px;
}
.mapping-container .mapping-search-bar .mapping-search-input-wrapper {
  border: 1px solid #6A8991;
  padding: 3px;
  border-radius: 10px;
  width: 310px;
}
.mapping-container .mapping-search-bar .mapping-search-input-wrapper .mapping-search-input {
  resize: none;
  background-color: transparent;
  font-size: 16px;
  color: #6A8991;
  outline: none;
  padding: 3px;
  border: 0;
  width: 300px;
}
.mapping-container .mapping-search-bar .mapping-search-file-input {
  background-color: #40A0C1;
  font-size: 18px;
  outline: none;
  padding: 7px 12px;
  border-radius: 20px;
  border: 0;
  color: white;
  cursor: pointer;
  white-space: nowrap;
}
.mapping-container .mapping-search-bar .mapping-search-file-input:hover {
  opacity: 0.95;
}
.mapping-container .mapping-search-bar .mapping-search-file-name {
  padding: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mapping-container .mapping-search-bar .mapping-radio-row {
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  font-weight: 500;
  color: #142A31;
  padding-top: 10px;
}
.mapping-container .mapping-search-bar .mapping-radio-title {
  font-size: 14px;
  font-weight: 500;
  color: #6A8991;
}
.mapping-container .mapping-search-bar .mapping-search-method-row {
  display: grid;
  grid-template-columns: 350px 120px 1fr;
  align-items: center;
  height: 60px;
}
.mapping-container .mapping-search-bar .mapping-go-button {
  cursor: pointer;
}
.mapping-container .mapping-search-bar .mapping-go-button:hover {
  opacity: 0.95;
}
.mapping-container .mapping-search-bar .mapping-info-box {
  background-color: #C9EBF6;
  padding: 8px 18px 8px 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
.mapping-container .mapping-search-bar .mapping-methods {
  display: grid;
  grid-template-columns: 180px 1fr;
  height: 110px;
}
.mapping-container .mapping-search-bar .mapping-fields {
  display: grid;
  grid-template-columns: 180px 1fr;
}
.mapping-container .mapping-search-bar .mapping-search-bar-half {
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 10px;
}
.mapping-container .mapping-results {
  flex-shrink: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.mapping-container .mapping-results .checkbox-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  filter: grayscale(100%);
}
.mapping-container .mapping-results .mapping-link {
  color: #6A8991;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.mapping-container .mapping-results .mapping-search-title {
  font-size: 14px;
  font-weight: 700;
  padding: 30px;
  color: #062229;
}
.mapping-container .mapping-results .mapping-table-wrapper {
  flex-shrink: 1;
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
  max-height: calc(100vh - 260px);
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  display: block;
  border-right-width: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table > thead {
  display: flex;
  background-color: #F5F9FF;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table > tbody {
  display: flex;
  flex-direction: column;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table .selected-row {
  background-color: rgba(211, 225, 237, 0.31) !important;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table .mapping-table-similar-tag {
  padding: 2px 1px;
  border: 1px solid #006400;
  border-radius: 4px;
  width: 38px;
  display: flex;
  color: #006400;
  font-size: 10px;
  align-items: center;
  justify-content: center;
  float: right;
  font-family: Arial;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table .mapping-table-header-cell {
  width: 300px;
  white-space: nowrap;
  background-color: transparent;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  height: 37px;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 0 20px 0 10px;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table .mapping-table-body-cell {
  width: 150px;
  white-space: nowrap;
  background-color: #FFFFFF;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 14px 20px 14px 10px;
}
.mapping-container .mapping-results .mapping-table-wrapper .mapping-table .mapping-table-links-column {
  color: blue;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/Mapping.scss"],"names":[],"mappings":"AAAA;EACC,0BAAA;EACA,aAAA;EACA,sBAAA;AACD;AAEC;EACC,eAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AAAF;AAGC;EACC,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAIE;EACC,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAFH;AAIG;EACC,YAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;AAFJ;AAME;EACC,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAJH;AAOE;EACC,aAAA;AALH;AAQE;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANH;AASE;EACC,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAPH;AAUE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AARH;AAWE;EACC,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;AATH;AAYE;EACC,eAAA;AAVH;AAaE;EACC,aAAA;AAXH;AAcE;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAZH;AAeE;EACC,aAAA;EACA,gCAAA;EACA,aAAA;AAbH;AAgBE;EACC,aAAA;EACA,gCAAA;AAdH;AAiBE;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AAfH;AAmBC;EACC,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAjBF;AAoBG;EACC,YAAA;EACA,mBAAA;EACA,uBAAA;AAlBJ;AAsBE;EACC,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AApBH;AAuBE;EACC,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AArBH;AAwBE;EACC,cAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;AAtBH;AAyBG;EACC,kBAAA;EACA,yBAAA;UAAA,iBAAA;EAGA,cAAA;EACA,qBAAA;EACA,2BAAA;EAAA,sBAAA;AAzBJ;AA2BI;EACC,aAAA;EACA,yBAAA;AAzBL;AA4BI;EACC,aAAA;EACA,sBAAA;AA1BL;AA8BI;EACC,sDAAA;AA5BL;AA+BI;EACC,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AA7BL;AAgCI;EACC,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,sBAAA;AA9BL;AAiCI;EACC,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AA/BL;AAkCI;EACC,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0BAAA;AAhCL","sourcesContent":[".mapping-container {\n\theight: calc(100vh - 80px);\n\tdisplay: flex;\n\tflex-direction: column;\n\n\n\t.mapping-search-back {\n\t\tpadding: 20px 0;\n\t\tcolor: blue;\n\t\tuser-select: none;\n\t\tcursor: pointer;\n\t}\n\n\t.mapping-search-bar {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tmargin: 20px 0 30px;\n\t\t//border-bottom: 1px solid #C3C8CA;\n\n\t\t.mapping-search-input-wrapper {\n\t\t\tborder: 1px solid #6A8991;\n\t\t\tpadding: 3px;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 310px;\n\n\t\t\t.mapping-search-input {\n\t\t\t\tresize: none;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #6A8991;\n\t\t\t\toutline: none;\n\t\t\t\tpadding: 3px;\n\t\t\t\tborder: 0;\n\t\t\t\twidth: 300px;\n\t\t\t}\n\t\t}\n\n\t\t.mapping-search-file-input {\n\t\t\tbackground-color: #40A0C1;\n\t\t\tfont-size: 18px;\n\t\t\toutline: none;\n\t\t\tpadding: 7px 12px;\n\t\t\tborder-radius: 20px;\n\t\t\tborder: 0;\n\t\t\tcolor: white;\n\t\t\tcursor: pointer;\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t\t.mapping-search-file-input:hover {\n\t\t\topacity: 0.95;\n\t\t}\n\n\t\t.mapping-search-file-name {\n\t\t\tpadding: 10px;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t.mapping-radio-row {\n\t\t\tuser-select: none;\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t\tcolor: #142A31;\n\t\t\tpadding-top: 10px;\n\t\t}\n\n\t\t.mapping-radio-title {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t\tcolor: #6A8991;\n\t\t}\n\n\t\t.mapping-search-method-row {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 350px 120px 1fr;\n\t\t\talign-items: center;\n\t\t\theight: 60px;\n\t\t}\n\n\t\t.mapping-go-button {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.mapping-go-button:hover {\n\t\t\topacity: 0.95;\n\t\t}\n\n\t\t.mapping-info-box {\n\t\t\tbackground-color: #C9EBF6;\n\t\t\tpadding: 8px 18px 8px 8px;\n\t\t\tborder-radius: 5px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\twidth: fit-content;\n\t\t}\n\n\t\t.mapping-methods {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 180px 1fr;\n\t\t\theight: 110px;\n\t\t}\n\n\t\t.mapping-fields {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 180px 1fr;\n\t\t}\n\n\t\t.mapping-search-bar-half {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tfont-weight: bold;\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\n\t.mapping-results {\n\t\tflex-shrink: 1;\n\t\tmin-height: 0;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\n\t\t.checkbox-primary {\n\t\t\t&:disabled {\n\t\t\t\topacity: 0.4;\n\t\t\t\tcursor: not-allowed;\n\t\t\t\tfilter: grayscale(100%);\n\t\t\t}\n\t\t}\n\n\t\t.mapping-link {\n\t\t\tcolor: #6A8991;\n\t\t\tfont-size: 14px;\n\t\t\tuser-select: none;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.mapping-search-title {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 700;\n\t\t\tpadding: 30px;\n\t\t\tcolor: #062229;\n\t\t}\n\n\t\t.mapping-table-wrapper {\n\t\t\tflex-shrink: 1;\n\t\t\tflex: 1;\n\t\t\toverflow-y: auto;\n\t\t\tmin-height: 0;\n\t\t\tmax-height: calc(100vh - 260px); // adjust this for header height\n\n\n\t\t\t.mapping-table {\n\t\t\t\tposition: relative;\n\t\t\t\tuser-select: none;\n\t\t\t\t// overflow: auto;\n\t\t\t\t// max-height: calc(100vh - 420px);\n\t\t\t\tdisplay: block;\n\t\t\t\tborder-right-width: 0;\n\t\t\t\tmin-width: fit-content;\n\n\t\t\t\t>thead {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tbackground-color: #F5F9FF;\n\t\t\t\t}\n\n\t\t\t\t>tbody {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t}\n\n\n\t\t\t\t.selected-row {\n\t\t\t\t\tbackground-color: rgba(211, 225, 237, 0.31) !important;\n\t\t\t\t}\n\n\t\t\t\t.mapping-table-similar-tag {\n\t\t\t\t\tpadding: 2px 1px;\n\t\t\t\t\tborder: 1px solid #006400;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\twidth: 38px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tcolor: #006400;\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tfont-family: Arial;\n\t\t\t\t}\n\n\t\t\t\t.mapping-table-header-cell {\n\t\t\t\t\twidth: 300px;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\theight: 37px;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmin-width: fit-content;\n\t\t\t\t\tpadding: 0 20px 0 10px;\n\t\t\t\t}\n\n\t\t\t\t.mapping-table-body-cell {\n\t\t\t\t\twidth: 150px;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\tbackground-color: #FFFFFF;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tpadding: 14px 20px 14px 10px;\n\t\t\t\t}\n\n\t\t\t\t.mapping-table-links-column {\n\t\t\t\t\tcolor: blue;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tuser-select: none;\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
